import { render, staticRenderFns } from "./DiagnosticoSocioambientalTerritorio.vue?vue&type=template&id=12a6a482&lang=pug"
import script from "./DiagnosticoSocioambientalTerritorio.vue?vue&type=script&lang=js"
export * from "./DiagnosticoSocioambientalTerritorio.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticoSocioambientalTerritorio.vue?vue&type=style&index=0&id=12a6a482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports